import {type MouseEventHandler} from 'react';
import {Grid, Typography} from '@mui/material';
import {BackButton} from 'components/buttons';

type AdminBookmarksFolderHeaderProps = {
  handleBack: MouseEventHandler;
  name: string;
}

const AdminBookmarksFolderHeader = ({ handleBack, name } : AdminBookmarksFolderHeaderProps) => {
  return (
    <Grid item xxs={12}>
      <Grid container spacing={2} alignItems='center'>
        <Grid item>
          <BackButton onClick={handleBack} />
        </Grid>
        <Grid item>
          <Typography variant='h3' color='white'>
            {name}
          </Typography>
        </Grid>
      </Grid>
    </Grid>
  )
}

export default AdminBookmarksFolderHeader;